import { render, staticRenderFns } from "./MSOffers.vue?vue&type=template&id=86882e12"
import script from "./MSOffers.vue?vue&type=script&lang=js"
export * from "./MSOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports